import { DefaultLanguage } from "src/constants";
import { Language } from "src/models";
import { store } from "src/store";

export namespace StringService {

    interface IStringMapper {
        [key: string]: string | number;
    }

    const characterMap: IStringMapper = {
        "۹": 9,
        "۸": 8,
        "۷": 7,
        "۶": 6,
        "۵": 5,
        "۴": 4,
        "۳": 3,
        "۲": 2,
        "۱": 1,
        "۰": 0,
        "ي": "ی",
        "ك": "ک",
        "ة": "ه"
    };

    let _lang: Language | undefined = undefined;

    const numberRegex = /[^0-9]/g;
    const phoneRegex = /(\d{4})(\d{3})(\d{4})/;
    const priceRegex = /\B(?=(\d{3})+(?!\d))/g;
    const lastWhitespaceRegex = /\s*$/g;
    const whitespaceRegex = /\s+/g;
    const multiDashRegex = /-+/g;

    export const toPhone = (phone: string) => {
        if (!phone) return "";
        return phone.replace(numberRegex, "")
            .replace(phoneRegex, "$1 $2 $3");
    };

    export const toPrice = (price: number | string) => {
        if (!price && price !== 0) return "";
        return price.toString().replace(priceRegex, ",");
    };

    export const normalize = (text: string) => {
        if (!text) return "";
        text = text.trim();
        const map = Array.prototype.map;
        const normalizeText = map.call(text, (char) => {
            if (characterMap[char] !== undefined) {
                char = characterMap[char];
            }
            return char;
        });
        return normalizeText.join("");
    };

    export const sanitize = (text: string) => {
        if (!text) return "";
        text = text.replace(lastWhitespaceRegex, "");
        text = text.replace(whitespaceRegex, "-");
        text = text.replace(multiDashRegex, "-");
        return text;
    };

    export const toFixed = (value: number, digit: number) => {
        const zeros = [...new Array(digit)].map((x) => "0").join("");
        return `${zeros}${value}`.slice(-digit);
    };

    export const toHtml = (value: string) => {
        return value?.replace(/\n/g, '<br />');
    };

    export const Dictionary = () => {
        if (_lang === undefined) {
            const config = store.store.getState()?.ConfigState;
            if (!config.loading) {
                _lang = config?.config?.appSetting?.language;
            }
        }
        return _lang;
    };

    export const Lang = (key: string) => {
        if (_lang === undefined) {
            const config = store.store.getState()?.ConfigState;
            if (!config.loading) {
                _lang = config?.config?.appSetting?.language;
            }
        }
        const result = (_lang ? _lang[key] || DefaultLanguage[key] : DefaultLanguage[key]);

        return result === "" ? "" : (result || key || "");
    };
}